module.exports = __webpack_public_path__ + "static/converge8-cbe0e1b744bad1ca0d7841705d3f1c5b.jpg";